import React from 'react';
import PropTypes from 'prop-types';

import './res_lookup_page_container.scss'
import InputWithIcon from '../components/input_with_icon'
import NoticeBox from '../components/notice_box'

export default class ResLookupPageContainer extends React.Component
  constructor: (props) ->
    super(props)
    @state = {
      currentValidationType: Object.keys(@props.validationModes)[0],
      notice: null
    }

  submitForm: (e) =>
    e.preventDefault()
    @setState notice: null
    $(@refs.submit).button('loading')
    $.post(@props.submitURL, $(@refs.form).serialize())
      .then (data) =>
        if data.error
          @setState notice: data.error
          $(@refs.submit).button('reset')

  renderNoticeBox: ->
    notice = @props.notice || @state.notice
    return null unless notice
    <NoticeBox type="error" content={{ message: notice }}/>

  renderValidationModes: ->
    <select className="form-control" name="validation_mode"
            onChange={(e) => @setState(currentValidationType: e.target.value)}>
      {for value, label of @props.validationModes
        <option value={value} key={value}>{label}</option>}
    </select>

  render: ->
    <div className="res-lookup-page">
      <div className="res-lookup-header"
           dangerouslySetInnerHTML={{__html: @props.content.header}}/>
      {@renderNoticeBox()}

      <form role="form" ref="form">
        <div className="hudson-subsection ma-panel panel">
          <div className="row">
            <div className="col-sm-4">
              <label dangerouslySetInnerHTML={{__html: @props.content.resNumLabel}}/>
              <InputWithIcon className="res-number" name="resid"/>
            </div>
            <div className="col-sm-4 validation-type">
              <div className="form-group">
                <label dangerouslySetInnerHTML={{__html: @props.content.validationTypeLabel}}/>
                {@renderValidationModes()}
              </div>
            </div>
            <div className="col-sm-4 validation-value">
              <div className="form-group">
                <label>
                  {@props.validationModes[@state.currentValidationType]}
                </label>
                <InputWithIcon name="validation_value"/>
              </div>
            </div>
          </div>
        </div>

        <div style={{textAlign: 'right'}}>
          <button ref="submit"
              data-loading-text={@props.content.submitLoading}
              onClick={@submitForm} className="ma-button btn btn-hudson">
            {@props.content.submitLabel}
          </button>
        </div>
      </form>
    </div>

ResLookupPageContainer.propTypes = {
  content: PropTypes.shape({
    header: PropTypes.string,
    resNumLabel: PropTypes.string,
    submitLabel: PropTypes.string,
    submitLoading: PropTypes.string,
    validationTypeLabel: PropTypes.string,
    validationValueLabel: PropTypes.string
  }),
  notice: PropTypes.object,
  submitURL: PropTypes.string,
  validationModes: PropTypes.object
}
